import React from 'react'

export const QueryBanner = () => (
    <div className = "bannerQuery">
        <div className = "titleBanner Title">
            <h3>Catálogo de sismos</h3>
        </div>
    </div>
);
